import { Requestor, Request } from '@viddsee/server-api-client';
import cloneDeep from 'lodash/cloneDeep';
import { authGetter } from './webcall-base/getters/auth';
import { getDomainUserId } from './webcall-base/helpers/deviceIdentification';

export const axiosConfiguration: Requestor.RequestConfig = {
  baseURL: '/v3',
};

export const authInterceptor = (config: Requestor.RequestConfig): Promise<Requestor.RequestConfig> | Requestor.RequestConfig => config;

export const baseConfiguration: Requestor.BaseApiConfig = {
  request: axiosConfiguration,
  auth: {
    getter: authGetter,
    alwaysAuth: true,
  },
  interceptor: {
    request: [
      async(config): Promise<Requestor.RequestConfig> => {
        const baseUrl = new URL(config.baseURL || '', location.origin);
        const requestUrl = new URL(config.url || '', baseUrl.href);
        if (requestUrl.origin !== location.origin) {
          return config;
        }

        config.headers = {
          ...{
            DeviceType: 'web',
            Udid: await getDomainUserId() || '',
          } as Request.Common.DeviceIdentificationHeaders,
          ...config.headers,
        };
        return config;
      },
    ],
  },
};

export const extendFromBaseConfiguration = (extendConfigFn: (config: Requestor.BaseApiConfig) => Requestor.BaseApiConfig): Requestor.BaseApiConfig => {
  if (!extendConfigFn) {
    return baseConfiguration;
  }

  // Deep cloning baseConfiguration to prevent extension function to modify baseConfiguration
  return extendConfigFn(cloneDeep(baseConfiguration));
};
